import styles from "./styles.module.css";
import SchemaItem from "./schemaitem";
import { useEffect, useState } from "react";
import { makeid } from "../../../utils/pageactions";
import SampleResponse from "./sampleresponse";
import { MdArrowDownward } from "react-icons/md";
import { db } from "../../../firebase";

export default function Config({ webhook, setHook, appId }) {
  const [name, setName] = useState("");
  const [toggle, setToggle] = useState(false);
  const [version, setVersion] = useState("development");
  const [type, setType] = useState("manual");

  useEffect(() => {
    setName(webhook.name);
    setType(webhook.type);
  }, [webhook]);

  const handleNameUpdate = () => {
    const _hook = { ...webhook };
    _hook.name = name;
    setHook(_hook);
  };

  const addField = () => {
    const _hook = { ...webhook };
    _hook.schema.fields[makeid(16)] = { name: "", type: "Text", list: false };
    setHook(_hook);
  };

  const handleUpdateField = (field, id) => {
    const _hook = { ...webhook };
    _hook.schema.fields[id] = field;
    setHook(_hook);
  };

  const handleDeleteField = (id) => {
    const _hook = { ...webhook };
    delete _hook.schema.fields[id];
    setHook(_hook);
  };

  const handleSchemaToggle = (v) => {
    setType(v);
    const _webhook = { ...webhook };
    _webhook.schema = {
      fields: {},
      type: _webhook.name,
      name: _webhook.name,
      list: false,
    };
    _webhook.type = v;
    setHook(_webhook);
  };

  return (
    <div className={styles.config}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={styles.nameInput}
          onBlur={handleNameUpdate}
        />
        <MdArrowDownward
          className={
            toggle ? styles.toggleArrow + " " + styles.open : styles.toggleArrow
          }
          onClick={() => setToggle(!toggle)}
        />
      </div>{" "}
      <div
        className={
          toggle
            ? styles.configContainer + " " + styles.open
            : styles.configContainer
        }
      >
        <div style={{ marginBottom: 20 }}>
          <div className={styles.inputTitle}>Webhook URL</div>
          <div className={styles.smallToggle}>
            <div
              onClick={() => setVersion("development")}
              className={
                version === "development"
                  ? `${styles.smallToggleItem} ${styles.active}`
                  : styles.smallToggleItem
              }
            >
              Development
            </div>
            <div
              onClick={() => setVersion("production")}
              className={
                version === "production"
                  ? `${styles.smallToggleItem} ${styles.active}`
                  : styles.smallToggleItem
              }
            >
              Production
            </div>
          </div>
          <div className={styles.url} style={{ marginTop: 12 }}>
            <div style={{ margin: "15px 15px 25px 15px" }}>
              {`https://api.brevityapps.co/app/${appId}/${version}/webhooks/${encodeURI(
                webhook.name
              )}`}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <div className={styles.inputTitle}>Schema</div>
          <div className={styles.smallToggle}>
            <div
              onClick={() => handleSchemaToggle("manual")}
              className={
                type === "manual"
                  ? `${styles.smallToggleItem} ${styles.active}`
                  : styles.smallToggleItem
              }
            >
              Manual
            </div>
            <div
              onClick={() => handleSchemaToggle("sample")}
              className={
                type === "sample"
                  ? `${styles.smallToggleItem} ${styles.active}`
                  : styles.smallToggleItem
              }
            >
              Sample Response
            </div>
          </div>
          {type === "manual" && (
            <>
              {Object.keys(webhook.schema.fields).map((k) => {
                return (
                  <SchemaItem
                    onChange={(value) => handleUpdateField(value, k)}
                    key={k}
                    schema={webhook.schema.fields[k]}
                    onDelete={() => handleDeleteField(k)}
                  />
                );
              })}
              <button onClick={addField} className={styles.addField}>
                Add Field
              </button>
            </>
          )}
          {type === "sample" && (
            <SampleResponse webhook={webhook} onChange={setHook} />
          )}
        </div>
      </div>
    </div>
  );
}
